// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavigationBar_navbar__1VfvW"};